var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.variations),function(variation){return _c('ProductsFilterVariation',{key:variation.id,attrs:{"variation":variation,"header":_vm.header}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }